import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Reset18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.03032 2.03033L4.96966 0.969666L0.939331 5L4.96966 9.03033L6.03032 7.96967L3.81066 5.75H12C14.3148 5.75 16.25 7.68517 16.25 10C16.25 12.3148 14.3148 14.25 12 14.25H7V15.75H12C15.1318 15.75 17.75 13.1318 17.75 10C17.75 6.86817 15.1318 4.25 12 4.25H3.81065L6.03032 2.03033Z'
      fill='currentColor'
    />
  </Svg>
);

Reset18.displayName = 'Reset18';
export default Reset18;
